import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../../../lib/api';
import { useAuth } from '../../../contexts/AuthContext';

let hsnCache = null;

export const useHsnList = () => {
  const { authHeader } = useAuth();
  const [list, setList] = useState(hsnCache || []);
  useEffect(() => {
    if (hsnCache) return;
    axios.get(`${API}/gst/hsn`, { headers: authHeader() })
      .then(({ data }) => { hsnCache = data || []; setList(hsnCache); })
      .catch(() => {});
  }, [authHeader]);
  return list;
};

// Saved HSN/SAC codes as suggestions; any other code can still be typed.
export const HsnInput = ({ value, onPick, list, className, testId }) => {
  const id = `hsn-opts-${testId}`;
  const pick = (code) => {
    const found = list.find((h) => h.code === code);
    onPick(found ? { hsn_code: found.code, gst_rate: found.default_gst_rate } : { hsn_code: code });
  };
  return (
    <>
      <input list={id} value={value || ''} onChange={(e) => pick(e.target.value)}
        className={className} placeholder="HSN/SAC" autoComplete="off" data-testid={testId} />
      <datalist id={id} data-testid={`${testId}-options`}>
        {list.map((h) => (
          <option key={h.id || `${h.type}-${h.code}`} value={h.code}>
            {h.type} {h.code} — {h.description} ({h.default_gst_rate}%)
          </option>
        ))}
      </datalist>
    </>
  );
};

// Line total that selects its whole amount on click so a fresh figure replaces it.
export const LineTotalInput = ({ target, computed, onChange, ...rest }) => {
  const [draft, setDraft] = useState(null);
  const locked = target !== '' && target != null && Number(target) > 0;
  const shown = draft ?? (locked ? target : (computed || ''));
  return (
    <input
      type="number" inputMode="decimal" min="0" step="0.01"
      value={shown}
      onFocus={(e) => { setDraft(String(shown)); const el = e.target; requestAnimationFrame(() => el.select()); }}
      onChange={(e) => { setDraft(e.target.value); onChange(e.target.value); }}
      onBlur={() => setDraft(null)}
      placeholder="0.00"
      {...rest}
    />
  );
};
